export default "__VITE_ASSET__BmchuPnc__"